export default __webpack_public_path__ + "static/media/externalLink.9929679e.svg";